import { useContext, useEffect, useState } from "react";
import { IMenuItem } from "../../shared/components/menubar/MenuBar";
import { AdminScreenTabs } from "../../shared/util/constant";
import { useHistory, useLocation, Route } from "react-router-dom";
import { Row, Column, Label, Navbar } from "../../components";
import './AdminMenuBar.scss'
import Nav from 'react-bootstrap/Nav';
import { Container, Dropdown, NavDropdown } from "react-bootstrap";
import UserSetupGrid from '../UserSetup/UserSetup/UserSetupGrid';
import RolePrivilegeMain from '../RolePrivilegeSetup/RolePrivilegeSetupMain/RolePrivilegeMain'
import * as constant from '../../shared/util/constant';
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import AppContext from "../../shared/components/AppContext";
import CarrierManagementMain from '../../Maintenance/CarrierManagement/CarrierManagementMain';

import { AbilityContext } from '../../shared/abilities/AbilityContext';

interface Props {
  isSideBarCollapsed: boolean
}
 
const adminMenuItems: IMenuItem[] = [
  //{ menuKey: AdminScreenTabs.general.key, menuText: AdminScreenTabs.general.text },
  { menuKey: AdminScreenTabs.usersetup.key, menuText: AdminScreenTabs.usersetup.text },
  { menuKey: AdminScreenTabs.roleprivilege.key, menuText: AdminScreenTabs.roleprivilege.text },
  { menuKey: AdminScreenTabs.security.key, menuText: AdminScreenTabs.security.text },
  //{ menuKey: AdminScreenTabs.company.key, menuText: AdminScreenTabs.company.text },
  //{ menuKey: AdminScreenTabs.agency.key, menuText: AdminScreenTabs.agency.text }
];
 
const AdminMenuBar = (props: Props) => {
 
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--marginLeftCustomerRow', props.isSideBarCollapsed ? '100px' : '250px')
  }, [props.isSideBarCollapsed]);
 
  const history = useHistory();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState('');
  const [currentSubMenus, setCurrentSubMenus] = useState([]);
  const [activeMenuKey, setActiveMenuKey] = useState(null);
  const [activeParentKey, setActiveParentKey] = useState(null);
  const [activeMenuText, setActiveMenuText] = useState("ADMIN");
  const [userSetupKey, setUserSetupKey] = useState(0);
  const modalContext = useConfirmationModalContext();
  const adminMenuContext = useContext(AppContext);
  const ability = useContext(AbilityContext);

  // On mount/refresh, determine active menu from URL
  useEffect(() => {
    const path = location.pathname;
    const segment = path.replace('/admin/', '').split('/')[0];
    if (!segment) return;
    // Check if segment is a direct menu key
    const directMenu = adminMenuItems.find(m => m.menuKey === segment);
    if (directMenu) {
      setActiveParentKey(segment);
      setCurrentTab(segment);
      return;
    }
    // Check if segment is a submenu key
    for (const menu of adminMenuItems) {
      const submenus = AdminScreenTabs[menu.menuKey]?.submenus || [];
      if (submenus.find(s => s.menuKey === segment)) {
        setActiveParentKey(menu.menuKey);
        setCurrentTab(segment);
        return;
      }
    }
  }, []);

  // Map menu keys to their admin screen privilege fields
  const adminScreenPrivilegeMap: Record<string, string> = {
    [AdminScreenTabs.usersetup.key]: constant.AdminScreenPrivileges.User_Setup,
    [AdminScreenTabs.roleprivilege.key]: constant.AdminScreenPrivileges.Role_Privilege_Setup,
    [AdminScreenTabs.security.key]: constant.AdminScreenPrivileges.Security,
  };

  const getMenuVisibility = (menuKey: string): { isVisible: boolean; isDisabled: boolean } => {
    const privilegeField = adminScreenPrivilegeMap[menuKey];
    if (!privilegeField) return { isVisible: true, isDisabled: false };
    const canView = ability.can('view', constant.AdminSubject, privilegeField);
    const canRead = ability.can('read', constant.AdminSubject, privilegeField);
    return { isVisible: canView, isDisabled: !canRead };
  };
 
  const handleSubmenuClick = async (menuKey: string, menuText: string) => {
    setActiveMenuKey(menuKey);
    setActiveMenuText(menuText)
    history.push(`/admin/${currentTab}/${menuKey}`)
  }

  const clearActiveLinks = () => {
    var tabLinks = document.querySelectorAll(".admin-nav-scope .nav-link");
    tabLinks.forEach(function (item) {
      item.classList.remove("active");
    });
  };

  // Apply active class after render based on activeParentKey
  useEffect(() => {
    if (!activeParentKey) return;
    clearActiveLinks();
    const parentMenu = adminMenuItems.find(m => m.menuKey === activeParentKey);
    if (!parentMenu) return;
    const navLinks = document.querySelectorAll(".admin-nav-scope .nav-link");
    navLinks.forEach((link) => {
      if (link.textContent?.trim() === parentMenu.menuText) {
        link.classList.add("active");
      }
    });
  }, [activeParentKey]);
 
  const onMenuItemClick = async (menuKey: string, menuText: string, parentKey?: string, event?: any) => {
    // Check if AdminScreenTabs[menuKey] exists before accessing submenus
    if (!AdminScreenTabs[menuKey] || AdminScreenTabs[menuKey].submenus === undefined) {
      setCurrentSubMenus([]);
    } else {
      setCurrentSubMenus(AdminScreenTabs[menuKey].submenus);
    }
 
    if (!adminMenuContext.formSavedStatus) {
      const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
      if (result) {
        setCurrentTab(menuKey);
        setActiveMenuKey(menuKey);
        setActiveParentKey(parentKey || menuKey);
        setActiveMenuText(menuText)
        history.push(`/admin/${menuKey}`)
        adminMenuContext.formSavedStatus = true
        // Force UserSetupGrid to remount when usersetup menu is clicked
        if (menuKey === AdminScreenTabs.usersetup.key) {
          setUserSetupKey(prev => prev + 1);
        }
      }
    }
    else {
      setCurrentTab(menuKey);
      setActiveMenuKey(menuKey);
      setActiveParentKey(parentKey || menuKey);
      setActiveMenuText(menuText)
      history.push(`/admin/${menuKey}`)
      // Force UserSetupGrid to remount when usersetup menu is clicked
      if (menuKey === AdminScreenTabs.usersetup.key) {
        setUserSetupKey(prev => prev + 1);
      }
    }
  }
 
  let otherPages = <>
    {/* {currentTab == AdminScreenTabs.general.key}
    {currentTab == AdminScreenTabs.company.key} */}
    {currentTab == AdminScreenTabs.usersetup.key}
    {currentTab == AdminScreenTabs.roleprivilege.key}
    {currentTab == AdminScreenTabs.security.key}
    {/* {currentTab == AdminScreenTabs.agency.key} */}
</>;
 
  let menusToRender = adminMenuItems;
 
  useEffect(() => {
    if (activeMenuKey && AdminScreenTabs[activeMenuKey]?.submenus) {
      setCurrentSubMenus(AdminScreenTabs[activeMenuKey].submenus);
    }
  }, [activeMenuKey]);
  
  let adminMenuBarContent = (
    <div className="admin-nav-scope">
    <Navbar
      bg="light"
      variant="light"
      className='py-0'
      navItems={[
        {
          type: 'header',
          label: 'Admin',
          className: 'cstHeaderMenu nav-add-new d-none d-md-block cst-header-menu-default',
          iconClassName: 'align-bottom',
          size: 'lg'
        },
        ...menusToRender.filter(menu => {
          const { isVisible } = getMenuVisibility(menu.menuKey);
          return isVisible;
        }).map(menu => {
          const hasSubmenus = AdminScreenTabs[menu.menuKey]?.submenus;
          const submenus = hasSubmenus ? AdminScreenTabs[menu.menuKey].submenus : [];
          const { isDisabled } = getMenuVisibility(menu.menuKey);

          return hasSubmenus ? {
            type: 'link-list',
            label: menu.menuText,
            className: 'cstHeaderMenu nav-add-new d-none d-md-block',
            alignRight: false,
            children: submenus.map(submenu => ({
              type: 'link',
              label: submenu.menuText,
              className: 'poppins-regular',
              onClick: (event) => onMenuItemClick(submenu.menuKey, submenu.menuText, menu.menuKey, event)
            }))
          } : {
            type: 'link',
            label: menu.menuText,
            name: menu.menuText,
            className: `cstHeaderMenu nav-add-new d-none d-md-block${isDisabled ? " disabled" : ""}`,
            iconClassName: 'align-bottom',
            size: '10x',
            alignRight: true,
            children: null,
            disabled: isDisabled,
            onClick: isDisabled ? undefined : (event) => onMenuItemClick(menu.menuKey, menu.menuText, undefined, event)
          };
        })
      ]} children={""} title={""}    />
    </div>
  );
//   let adminMenuBarContent = <>
// <Navbar bg="primary" data-bs-theme="dark">
//       {menusToRender.map(menu => (
//         AdminScreenTabs[menu.menuKey].submenus ? (
// <Dropdown className="AdminDropdown" key={menu.menuKey}>
// <Dropdown.Toggle variant="success" id="dropdown-basic" onClickCapture={() => { onMenuItemClick(menu.menuKey, menu.menuText) }} className={(menu.menuKey === activeMenuKey ? "active" : "")}>
//               {menu.menuText}
// </Dropdown.Toggle>
 
//             <Dropdown.Menu>
//               {currentSubMenus.map((submenu) => (
// <Dropdown.Item eventKey={submenu.menuKey} href={''} onClick={() => handleSubmenuClick(submenu.menuKey, submenu.menuText)}>
//                   {submenu.menuText}
// </Dropdown.Item>
//               ))}
// </Dropdown.Menu>
// </Dropdown>
//         ) : (
// <Nav.Link onClick={() => onMenuItemClick(menu.menuKey, menu.menuText)} key={menu.menuKey} href={''} className={"adminNavLink " + (menu.menuKey === currentTab ? "active" : "")}>
//             {menu.menuText}
// </Nav.Link>
//         )
//       ))}
// </Navbar>
// </>;
 
  return (
<>

{adminMenuBarContent}

<Route
        exact
        path="/admin/usersetup"
        // component={UserSetupGrid}
        render={() => <UserSetupGrid key={userSetupKey} />}
      />
<Route
        exact
        path="/admin/roleprivilege/:roleId?"
        render={() => <RolePrivilegeMain />}
      />
{/* <Route
        exact
        path="/admin/agency/:groupId?"
        render={() => <AgencySetupMain />}
      /> */}
  <Route
    exact
    path="/admin/carrier-management"
    render={() => <CarrierManagementMain />}
          />

</>
  );
 
}
 
export default AdminMenuBar